import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/facilities/$facilityKey/groups/$groupKey/modification",
)({
  beforeLoad() {
    // 過去に使用されていたルートを最新のルートにリダイレクトする。
    throw redirect({ to: ".." });
  },
});
